import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StockoutproducttoproductorderEditForm from './StockoutproducttoproductorderEditForm';
import StockoutproducttoproductorderList from './StockoutproducttoproductorderList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StockoutproducttoproductorderListView from './StockoutproducttoproductorderListView'


export default function StockoutproducttoproductorderDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stockoutproducttoproductorderDashboard);
  const [ stockoutproducttoproductorderId, setStockoutproducttoproductorderId] = React.useState('');
  const [reloadStockoutproducttoproductorderList, setReloadStockoutproducttoproductorderList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StockoutproducttoproductorderEditForm 
            setReloadStockoutproducttoproductorderList={setReloadStockoutproducttoproductorderList}
            stockoutproducttoproductorderId={stockoutproducttoproductorderId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StockoutproducttoproductorderListView 
                      setStockoutproducttoproductorderId = {setStockoutproducttoproductorderId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
